export const LANDING_CAMPAIGN_STORAGE_KEY = 'landingCampaignId';
export const LANDING_CALLBACK_RETRY_KEY = 'landingCallbackRetry';
